<template>
  <div>
    <section class=" container section is-main-section">
      <v-card-component title="Edit Vehicle Staff Details" icon="mdi-bus">
      <form @submit.prevent="save">
        <div>
               <v-card-actions>
        <router-link :to="{ name: 'vehicleStaff' }">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
        </router-link>
      </v-card-actions>
<v-row>
<v-col>
      <v-row>
       <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium"> Name <span class="error--text ml-1">*</span></span>
        <v-text-field v-model.trim="name" required class="my-0 py-1">
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium"> Unique Identification Number <span class="error--text ml-1">*</span></span>
        <v-text-field v-model.trim="uniqueIdentificationNumber" required class="my-0 py-1">
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium"> License Number <span class="error--text ml-1">*</span></span>
        <v-text-field v-model.trim="licenseNumber" required class="my-0 py-1" type="text">
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="3" md="6">
              <label class="body-2 font-weight-medium"> License Expiry Date <span class="error--text ml-1">*</span></label>
              <custom-date-picker v-model="licenseExpiryDate" />
            </v-col>
    </v-row>
</v-col>
</v-row>
   <div class="columns form-row">
             <v-col cols="12" md="6" lg="4">
              <label class="body-2 font-weight-medium">Select Photo</label>
              <v-file-input :messages="['(Only .jpg, .jpeg , .png format is allowed)']" class="my-0 py-1"
              v-model="dropFile" accept="image/*" @input="onFilechange()" show-size placeholder="Click to Upload"></v-file-input>
            </v-col>
            <v-col cols="12" md="6" lg="4">
              <label class="body-2 font-weight-medium">Select licence</label>
              <v-file-input :messages="['(Only .jpg, .jpeg , .png format is allowed)']" class="my-0 py-1"
              v-model="licence" accept="image/*" @input="onFilechange()" show-size placeholder="Click to Upload"></v-file-input>
            </v-col>
          </div>
          <button class="button is-success" :disabled="hasClicked" type="submit" style="margin-top:20px;">Save</button>
        </div>
        <div></div>
      </form>
      <span v-if="dropFile1.length > 0">
        <span style="margin-top:50px;" class="has-text-primary">Already Uploaded Documents</span>
                    <div  class="tags" v-for="(file, i) in dropFile1" :key="i">
                     <div @click="download(file.urlPath)" class="tag is-primary">
                        {{file.documentType + ' ' + file.name}}
                      </div>
                    </div>
                  </span>
                  </v-card-component>
    </section>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import moment from 'moment'
import Utils from '@/utils'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import VCardComponent from '@/components/template/VCardComponent'
export default {
  name: 'editVehicleStaff',
  props: ['vehicleStaffID'],
  components: {
    VCardComponent,
    CustomDatePicker
  },
  data () {
    return {
      total: 0,
      dropFile: [],
      licence: [],
      name: '',
      mobileNumber: '',
      email: '',
      uniqueIdentificationNumber: '',
      licenseNumber: '',
      licenseExpiryDate: '',
      roles: '',
      isRequired: false,
      vehicleType: '',
      vehicleStaffData: [],
      vehicleStaffDocumentData: [],
      dropFile1: [],
      title: '',
      hasClicked: false,
      loader: true,
      isWrite: false,
      isDocRequired: true,
      allowedFiles: [
        'png', 'jpg', 'jpeg', 'pdf'
      ]
    }
  },

  async created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.vehicleStaffDetails()
    await this.vehicleStaffDetailsDocuments()
  },
  methods: {
    vehicleStaffDetails: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/transport/vehiclestaff/vehiclestaffdetails/${this.vehicleStaffID}`)
        this.vehicleStaffData = data
        this.name = this.vehicleStaffData.name
        this.uniqueIdentificationNumber = this.vehicleStaffData.uniqueIdentificationNumber
        this.licenseNumber = this.vehicleStaffData.licenseNumber
        this.licenseExpiryDate = moment(this.vehicleStaffData.licenseExpiryDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    vehicleStaffDetailsDocuments: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/transport/vehiclestaff/vehiclestaffdetails/${this.vehicleStaffID}`)
        this.vehicleStaffDocumentData = data
        this.dropFile1 = this.vehicleStaffDocumentData.vehicleStaffDocumentsMaps
        if (this.dropFile1) {
          this.dropFile1.forEach(docID => {
            docID.name = docID.urlKey.substring(docID.urlKey.lastIndexOf('/') + 1)
          })
        }
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    deleteDropFile (i) {
      this.dropFile.splice(i, 1)
    },
    save: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        let formData = new FormData()
        formData.append('name', this.name)
        formData.append('uniqueIdentificationNumber', this.uniqueIdentificationNumber)
        formData.append('licenseNumber', this.licenseNumber)
        formData.append('licenseExpiryDate', this.licenseExpiryDate)
        formData.append('vehicleStaffPhoto', this.dropFile)
        formData.append('vehicleStaffLicenseAttachements', this.licence)
        // for (var pair of formData.entries()) {
        //   console.log(pair)
        // }
        this.hasClicked = true

        await http.put(`${constants.API_URL}/api/transport/vehiclestaff/vehiclestaffdetails/${this.vehicleStaffID}`, formData)
        this.loader = false
        this.loadingComponent.close()
        this.$router.push({ name: 'vehicleStaff' })
        return this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Saved successfully',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Details', errorMessage)
        this.lock = false
        this.hasClicked = false
        this.loader = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    download: async function (i) {
      try {
        let url = await http.get(`${constants.API_URL}/api/staff/downloadurl?s3urlKey=${i}`)
        window.open(url.data)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting file details, ${errorMessage}`)
      }
    },
    onFilechange () {
      let r = this.dropFile.filter((a, i) => {
        if (this.allowedFiles.includes(a.name.split('.').pop())) {
        }
        return this.allowedFiles.includes(a.name.split('.').pop())
      })
      this.dropFile = r
    }
  }
}
</script>
